import React, { useState } from "react";
// componentes
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Button,
  Collapse,
  UncontrolledTooltip,
} from "reactstrap";
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// redux
import { useSelector } from "react-redux";
// services
import {
  getCertificateByName,
  updateCertificate,
} from "../../../utils/services/certificate";
import { getUrlFiles } from "../../../utils/services/files";

export default function ModalEditCertificate(props) {
  const { isOpen, toggle, certificate, eventId, refetch } = props;
  const { token: jwt } = useSelector((state) => state.global_user_data.data);

  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [tags, setTags] = useState(certificate.tags.map((tag) => tag.name));
  const [image, setImage] = useState(certificate.image);
  const [color, setColor] = useState(certificate.color);
  const [name, setName] = useState(certificate.name);
  // configurações do nome dos participantes
  const [fontSize, setFontSize] = useState(certificate.fontSize);
  const [textAlignment, setTextAlignment] = useState(
    certificate.textAlignment || "Selecione",
  );
  const [heightPosition, setHeightPosition] = useState(
    certificate.heightPosition,
  );
  const [widthPosition, setWidthPosition] = useState(certificate.widthPosition);
  //error state
  const [nameError, setNameError] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [fontSizeError, setFontSizeError] = useState(false);
  const [nameIsRegistered, setNameIsRegistered] = useState(false);
  const [heightError, setHeightError] = useState(false);
  const [widthError, setWidthError] = useState(false);
  const [alignError, setAlignError] = useState(false);
  // collapse
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);

  const [success, setSuccess] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  const [newImg, setNewImg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // adiciona uma tag, sem duplicar
  function addTags(newTags) {
    setTags([...new Set([...tags, newTags])]);
  }

  // remove a tag da posição informada
  function removeTags(index) {
    const newTags = [...tags];
    newTags.splice(index, 1);
    setTags(newTags);
  }

  // lê o arquivo de imagem selecionado e atualiza o preview
  const onImageChange = (event, setStateFunction) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setStateFunction(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  // valida o form, envia a nova imagem (se houver) e atualiza o certificado
  async function submitForm(e) {
    e.preventDefault();

    if (!name) {
      setNameError(true);
      return;
    } else setNameError(false);

    if (!image) {
      setImageError(true);
      return;
    } else setImageError(false);

    if (!fontSize) {
      setCollapseIsOpen(true);
      setFontSizeError(true);
      return;
    } else setFontSizeError(false);

    if (textAlignment === "Selecione") {
      setCollapseIsOpen(true);
      setAlignError(true);
      return;
    } else setAlignError(false);

    if (!heightPosition) {
      setCollapseIsOpen(true);
      setHeightError(true);
      return;
    } else setHeightError(false);

    if (!widthPosition) {
      setCollapseIsOpen(true);
      setWidthError(true);
      return;
    } else setWidthError(false);

    if (name !== certificate.name) {
      try {
        const nameAlreadyExists = await getCertificateByName({
          jwt,
          eventId,
          name,
        });

        if (nameAlreadyExists.data.message === "CERTIFICATE_FOUND") {
          setNameIsRegistered(true);
          return;
        } else setNameIsRegistered(false);
      } catch (error) {
        console.error("Erro ao verificar nome do certificado:", error);
        setSubmitErrorMessage("Erro ao verificar o nome do certificado.");
        return;
      }
    } else setNameIsRegistered(false);

    let urlFile = undefined;
    let expireDate = certificate.expireDate;
    let imageId = null;

    if (newImg.files) {
      const formData = new FormData();
      formData.append("files", newImg.files[0]);
      formData.append("name", name);
      formData.append("folder", "certificados");
      formData.append("eventId", eventId);

      try {
        const response = await getUrlFiles(formData, jwt);
        response.forEach((file) => {
          urlFile = file.url;
          expireDate = file.expires;
          imageId = file.fileId;
        });
      } catch (error) {
        console.error("Erro ao enviar a imagem:", error);
        setSubmitErrorMessage("Erro ao enviar a nova imagem.");
        return;
      }
    }

    const data = {
      name,
      eventId,
      imageId: imageId ? imageId : certificate.imageId,
      image: urlFile || image,
      fontSize: +fontSize,
      textAlignment,
      heightPosition: +heightPosition,
      widthPosition: +widthPosition,
      color: color,
      expireImage: expireDate,
      tags: tags.map((tag) => ({ name: tag })),
    };

    setIsLoading(true);
    try {
      await updateCertificate({ data, jwt, id: certificate.id });
      setSuccess(true);
      refetch();
    } catch (error) {
      console.error("Erro ao atualizar certificado:", error);
      setSubmitErrorMessage("Erro ao atualizar certificado.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => toggleBackdrop()}
      autoFocus
      centered
      size="lg"
    >
      {success && (
        <SweetAlert
          success
          title="Edição de Certificado"
          onConfirm={() => {
            setSuccess(false);
            toggle();
          }}
        >
          Certificado editado com sucesso!
        </SweetAlert>
      )}
      {submitErrorMessage && (
        <SweetAlert
          danger
          title="Erro"
          onConfirm={() => setSubmitErrorMessage("")}
        >
          {submitErrorMessage}
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Editar Certificado</ModalHeader>
      <ModalBody style={{ padding: 20 }}>
        <form onSubmit={submitForm}>
          <Row>
            <Col md={12}>
              <label className="form-label" style={{ padding: 0 }}>
                ID do Certificado
              </label>
              <input
                className="form-control"
                type="text"
                value={certificate?.id ? certificate.id : null}
                disabled
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col md={12}>
              <label className="form-label" style={{ padding: 0 }}>
                Nome*
              </label>
              <input
                className="form-control"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              {nameError && (
                <span className="text-danger">O campo Nome é obrigatório</span>
              )}
              {nameIsRegistered && (
                <span className="text-danger">
                  Já existe um certificado com esse nome
                </span>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col md={12}>
              <label className="form-label" style={{ padding: 0 }}>
                Tags
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Digite e pressione a tecla Enter para adicionar a Tag"
                onKeyDown={(e) => {
                  if (e.key === "Enter" && e.target.value) {
                    e.preventDefault();
                    e.stopPropagation();

                    addTags(e.target.value);
                    e.target.value = "";
                  }
                }}
              />
            </Col>
          </Row>

          {tags?.length > 0 && (
            <Row style={{ marginTop: 10 }}>
              <Col md={12}>
                <div className="tag-container" style={{ padding: 0 }}>
                  {tags.map((tag, index) => (
                    <div key={index} className="tag-wrapper">
                      <span className="tags-field">{tag}</span>
                      <i
                        className="mdi mdi-close"
                        onClick={() => removeTags(index)}
                      />
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          )}

          <Row style={{ marginTop: 10 }}>
            <Col md={6} style={{ display: "flex", alignItems: "center" }}>
              <label
                htmlFor="formFile"
                className="form-label"
                style={{ marginBottom: 0, display: "flex" }}
              >
                Imagem*{" "}
                <div
                  id="tooltipImgCertificate"
                  style={{ paddingRight: "7px", height: "16px" }}
                >
                  <div className="show-tips">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="tooltipImgCertificate"
                  >
                    Tamanho 1754x1240
                  </UncontrolledTooltip>
                </div>
              </label>
              <label htmlFor="inputImage" style={{ marginBottom: 0 }}>
                <i
                  className="bx bx-pencil"
                  style={{ cursor: "pointer", marginLeft: 5 }}
                />
              </label>
              <input
                id="inputImage"
                type={"file"}
                onChange={(e) => {
                  setNewImg({ files: e.target.files });
                  onImageChange(e, setImage);
                }}
                style={{ display: "none" }}
              />
            </Col>
            <Col md={6} style={{ display: "flex", alignItems: "center" }}>
              <img alt="edit" src={image} style={{ width: 70 }} />
            </Col>
            {imageError && (
              <span className="text-danger">
                O campo Upload de Imagem é obrigatório
              </span>
            )}
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <SectionComponent
              sectionName="Configurações do Nome dos Participantes"
              setIsOpen={setCollapseIsOpen}
              isOpen={collapseIsOpen}
            />
          </Row>

          <Collapse isOpen={collapseIsOpen}>
            <Row>
              <Col md={6}>
                <label className="form-label" style={{ padding: 0 }}>
                  Tamanho da Fonte*
                </label>
                <input
                  className="form-control"
                  type="number"
                  value={fontSize}
                  onChange={(e) => setFontSize(e.target.value)}
                />
                {fontSizeError && (
                  <span className="text-danger">
                    O campo Tamanho da Fonte é obrigatório
                  </span>
                )}
              </Col>

              <Col md={6}>
                <label className="form-label" style={{ padding: 0 }}>
                  Alinhamento do Texto*
                </label>
                <select
                  className="form-control"
                  value={textAlignment}
                  onChange={(e) => setTextAlignment(e.target.value)}
                >
                  <option>Selecione</option>
                  <option>Esquerda</option>
                  <option>Centro</option>
                  <option>Direita</option>
                </select>
                {alignError && (
                  <span className="text-danger">
                    O campo Alinhamento do Texto é obrigatório
                  </span>
                )}
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col md={6}>
                <label className="form-label" style={{ padding: 0 }}>
                  Posição em Altura*
                </label>
                <input
                  className="form-control"
                  type="number"
                  value={heightPosition}
                  onChange={(e) => setHeightPosition(e.target.value)}
                />
                {heightError && (
                  <span className="text-danger">
                    O campo Posição em Altura é obrigatório
                  </span>
                )}
              </Col>

              <Col md={6}>
                <label className="form-label" style={{ padding: 0 }}>
                  Posição Largura*
                </label>
                <input
                  className="form-control"
                  type="number"
                  value={widthPosition}
                  onChange={(e) => setWidthPosition(e.target.value)}
                />
                {widthError && (
                  <span className="text-danger">
                    O campo Posição Largura é obrigatório
                  </span>
                )}
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col md={12}>
                <label className="form-label">Cor*</label>
                <ColorPicker
                  classOfContainer="colorpiker-certificate"
                  labelText=""
                  setStateFunc={setColor}
                  defaultColor={color}
                  position="top"
                />
              </Col>
            </Row>
          </Collapse>

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                marginTop: 15,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="danger"
                style={{ width: 80 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>

              <ButtonSpinner
                isLoading={isLoading}
                title={"Salvar"}
                marginLeft={10}
                action="U"
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}
